export default __webpack_public_path__ + "static/media/Skup Pula (12).871e726a.JPG";